import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    users: { passengersUrl, webviewLink },
  },
} = config

/**
 * Get all passengers from user.
 *
 * @param {Object} params
 * @param {String} params.userId Id of the user in the database
 */
const get = (params) => axios.get(passengersUrl, { headers: getHeaders(true), params })

/**
 * Add new passenger to user.
 *
 * @param {Object} params
 * @param {String} params.userId Id of the user in the database
 * @param {String} passenger Passenger data to add
 */
const add = (params, passenger) => axios.post(passengersUrl, { passenger }, { headers: getHeaders(true), params })

/**
 * Update passenger from user.
 *
 * @param {Object} params
 * @param {String} params.userId Id of the user in the database
 * @param {String} passenger Passenger data to add
 */
const updateOne = (params, passenger) => axios.put(passengersUrl, { passenger }, { headers: getHeaders(true), params })

/**
 * Delete passenger from user.
 *
 * @param {Object} params
 * @param {String} params.userId Id of the user in the database
 * @param {String} params.passengerId Id of the passenger to delete
 */
const deleteOne = (params) => axios.delete(passengersUrl, { headers: getHeaders(true), params })


const getUrl = (userId) => webviewLink.replace(':userId', userId || '')

const getWebviewLink = userId => axios.get(getUrl(userId), { headers: getHeaders(true) })

export default { get, add, updateOne, deleteOne, getWebviewLink }
